import { Text, View, type StyleProp, type ViewStyle } from "react-native";
import { colors, semanticColors, typography } from "../theme/tokens";

type Props = {
  children: string;
  testID?: string;
  style?: StyleProp<ViewStyle>;
};

/**
 * The quiet footnote box at the end of a factsheet ("This information is for
 * educational purposes only…"): a neutral wash with centred faint text.
 */
export function DisclaimerNote({ children, testID, style }: Props) {
  return (
    <View
      testID={testID}
      style={[
        {
          backgroundColor: semanticColors.notice.quiet.background,
          borderRadius: 12,
          padding: 14,
        },
        style,
      ]}
    >
      <Text
        style={{
          fontFamily: typography.families.sans,
          fontSize: 11,
          lineHeight: 17,
          color: colors.textLight,
          textAlign: "center",
        }}
      >
        {children}
      </Text>
    </View>
  );
}

export default DisclaimerNote;
